import { Box, Card, Typography } from "@mui/material";
import { StatTileData } from "../types";

// Same look as the admin Overview cards: dark value, neutral icon badge, quiet label and meta.
export const StatTile = ({ data }: { data: StatTileData }) => {
  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid #e5e7eb",
        borderRadius: 3,
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
        height: "100%",
        p: { xs: 1.75, sm: 2.25 },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
        <Typography sx={{ fontSize: { xs: 12.5, sm: 13.5 }, fontWeight: 600, color: "#334155", lineHeight: 1.3 }}>
          {data.label}
        </Typography>
        <Box
          sx={{
            width: { xs: 32, sm: 38 },
            height: { xs: 32, sm: 38 },
            borderRadius: 2,
            backgroundColor: "rgba(25, 118, 210, 0.08)",
            color: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {data.icon}
        </Box>
      </Box>
      <Typography
        sx={{
          mt: 1,
          fontSize: { xs: "1.3rem", sm: "1.75rem" },
          fontWeight: 800,
          lineHeight: 1.15,
          letterSpacing: "-0.02em",
          color: "#0f172a",
          fontVariantNumeric: "tabular-nums",
          wordBreak: "break-word",
        }}
      >
        {data.value}
      </Typography>
      <Typography sx={{ display: "block", mt: 0.5, fontSize: 12, color: "text.secondary" }}>
        {data.meta}
      </Typography>
    </Card>
  );
};
